'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Upload = function Upload(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 15 15' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'g',
        { fill: 'currentColor', fillRule: 'evenodd' },
        _react2.default.createElement('path', { d: 'M14 8.037v3.5c0 .827-.673 1.5-1.5 1.5h-10c-.827 0-1.5-.673-1.5-1.5v-3.5H0v3.5c0 1.378 1.122 2.5 2.5 2.5h10c1.378 0 2.5-1.122 2.5-2.5v-3.5h-1z' }),
        _react2.default.createElement('path', { d: 'M7 1.623v9.414h1V1.623l2.718 2.698.564-.568L7.5 0 3.718 3.753l.564.568z' })
      )
    )
  );
};
/*eslint-enable */

exports.default = Upload;
//# sourceMappingURL=Upload.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/Upload.js